// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500&family=Raleway:wght@500&display=swap);"]);
// Module
exports.push([module.id, "/* SCROLLBAR */\n*::-webkit-scrollbar-track{\n    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n    background-color: #F5F5F5;\n}\n\n*::-webkit-scrollbar\n{\n    width: 5px;\n}\n\n*::-webkit-scrollbar-thumb\n{\n    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n    background-color: #b7c800;\n}\n/* SCROLLBAR */\n", ""]);
// Exports
module.exports = exports;
